var map = {
	"./globalvar.js": "NnR8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "EwO2";


//////////////////
// WEBPACK FOOTER
// ./src/utils nonrecursive globalvar\.js$
// module id = EwO2
// module chunks = 104